/* The shop's customers.
 *
 * Reading is internal staff; adding and changing is the office. The server
 * answers 403 to anyone else, so nothing here needs to ask — and a 409 from
 * either write is the duplicate check, whose message names the customer the new
 * details already belong to.
 *
 * One endpoint answers both callers, the way the jobs one does: the customers
 * screen asks for a page, sorted and searched by the server, and the job form's
 * picker and the duplicate check ask for the whole list in a single page. Same
 * ordering, same search, one place they can be wrong. */
import type {
  CreateCustomerRequest,
  CustomerDto,
  CustomersPageDto,
  ListCustomersQuery,
  UpdateCustomerRequest,
} from '@oneshot2pac/shared';
import { api } from './client';
import { queryString } from './query';

export const customersApi = {
  /** One page of the list — or, at `CUSTOMERS_ALL_SIZE`, every customer. */
  list: (query: ListCustomersQuery = {}) =>
    api.get<CustomersPageDto>(`/customers${queryString({ ...query })}`),

  create: (body: CreateCustomerRequest) => api.post<CustomerDto>('/customers', body),

  /** Send only what changed. A blank string clears a field; leaving it out
   *  leaves it alone. */
  update: (id: string, body: UpdateCustomerRequest) =>
    api.patch<CustomerDto>(`/customers/${id}`, body),
};
